import EventHandler, { GAME_EVENT } from "@/lib/SplashGame/EventHandler";
var NotificationHandler = /** @class */ (function () {
    function NotificationHandler() {
    }
    NotificationHandler.getInstance = function () {
        if (!this._instance) {
            this._instance = new NotificationHandler();
        }
        return this._instance;
    };
    NotificationHandler.prototype.load = function (scene) {
        this.scene = scene;
        return this;
    };
    NotificationHandler.prototype.on = function (type, listener) {
        var event = [GAME_EVENT.NOTIFICATION, type].join("-");
        EventHandler.getInstance().on(event, function (e) {
            var detail = e.detail;
            if (detail.type !== type)
                return;
            listener(detail.detail);
        });
    };
    NotificationHandler.prototype.remove = function (type, listener) {
        var event = [GAME_EVENT.NOTIFICATION, type].join("-");
        EventHandler.getInstance().remove(event, listener);
    };
    NotificationHandler.prototype.push = function (data) {
        EventHandler.getInstance().send([GAME_EVENT.NOTIFICATION, data.type].join("-"), false, data);
    };
    return NotificationHandler;
}());
export default NotificationHandler;
